import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from "react";
import { extractResumeDataDocumentSection } from "../../../hooks/useResumeDocumentSection";
import { extractResumeProperties } from "../../../hooks/useResumeProperties";
import { formatDate } from "../../../utils/formatDate";

export default function EuropassPdfDiplomasSection( { resumeData, translations } ) {

    const { diplomas } = extractResumeDataDocumentSection( resumeData );
    const { isAnonymous, documentLanguage } = extractResumeProperties( resumeData );

    const styles = StyleSheet.create( {
        bold: {
            fontWeight: 'bold',
        },
        textDate: {
            fontSize: 8,
            marginBottom: 0,
        },
        lineTitle: {
            height: 1,
            backgroundColor: "#979797",
            marginBottom: 5,
            marginTop: -5,
        },
        lineTitleEuropass: {
            height: 1,
            backgroundColor: "#979797",
            marginBottom: 5,
        },
    } );

    return (
        <View style={ { paddingHorizontal: 20, marginRight: 40 } } wrap={ false }>
            <View>
                <View style={ { marginTop: 10 } }>
                    <View style={ { flexDirection: "row", marginBottom: 4 } }>
                        <Text style={ { fontSize: 11, marginRight: 3 } }>•</Text>
                        <Text style={ { fontWeight: "bold", textTransform: "uppercase", fontSize: 9, marginTop: 2 } }>
                            { translations.pdf.diplomasTitle }
                        </Text>
                    </View>
                    <View style={ [ styles.lineTitle, { marginTop: 1 } ] }/>
                </View>
            </View>
            { diplomas
                .filter( ( diploma ) => diploma.from && ( diploma.to || diploma.isCurrent ) )
                .sort( ( a, b ) => a.order - b.order )
                .map( ( diploma, index ) => (
                    <View key={ `diploma-${ index }` }>
                        <View>
                            <View style={ styles.fullColumn }>
                                <View style={ { flexDirection: "column" } }>
                                    <Text style={ [
                                        styles.textDate,
                                        {
                                            marginTop: 5,
                                            textTransform: "uppercase"
                                        }
                                    ] }>
                                        { formatDate( diploma.from, documentLanguage ) }
                                        { " - " }
                                        { diploma.isCurrent ? translations.pdf.isCurrentLabel : formatDate( diploma.to, documentLanguage ) }
                                    </Text>
                                    <View style={ {
                                        flexDirection: "row",
                                        alignItems: "center",
                                        width: "95%",
                                        flexWrap: "wrap"
                                    } }>
                                        <Text style={ [
                                            styles.client,
                                            styles.bold, {
                                                textTransform: "uppercase",
                                                fontSize: 8
                                            }
                                        ] }>
                                            { diploma.diplomaTitle }{ ' ' }
                                        </Text>
                                        <Text style={ { color: "#3F3F3F", textTransform: "uppercase", fontSize: 8 } }>
                                            { isAnonymous ? translations.pdf.diplomasSchoolLabel : diploma.schoolName }
                                        </Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View style={ styles.lineTitleEuropass }/>
                    </View>
                ) )
            }
        </View>
    )
}
